
// This is mapped to the DB

export const OrganisationRole = {
    ADMIN: 1,
    APP_USER: 2,
    CONTENT_CONTRIBUTOR: 3
};

Object.freeze(OrganisationRole);